import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { api } from '../../utils/endpoints';
import { fileDirectories } from '../../utils/view-settings';

@Component({
  selector: 'app-sports-explorer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sports-explorer.component.html',
  styleUrl: './sports-explorer.component.scss',
})
export class SportsExplorerComponent implements OnInit {
  @Input() userLoggedIn = false;
  @Output() exploreClick = new EventEmitter<void>();

  sportsList: any[] = [];
  activeId: string = '';
  fileDirectoriesPath: string = fileDirectories.profile;
  loading = true;

  constructor(
    private _apiService: ApiCallsService,
    private _router: Router,
  ) {}

  ngOnInit(): void {
    this.getSports();
  }

  getSports() {
    this.loading = true;
    this._apiService.post(api._sportListing, { topSportSequence: true, limit: 5 }).subscribe({
      next: (res: any) => {
        if (res && res.data && res.data.rows) {
          this.sportsList = res.data.rows;
          if (this.sportsList.length > 0) {
            // Set the first sport as active by default
            this.activeId = this.sportsList[0].id;
          }
        }
        this.loading = false;
      },
      error: (error: any) => {
        console.error('Error fetching sports in explorer:', error);
        this.loading = false;
      },
    });
  }

  setActive(id: string) {
    this.activeId = id;
  }

  cleanHtml(html: string): string {
    if (!html) return '';
    // Strip HTML tags
    let text = html.replace(/<[^>]*>/g, '');
    // Replace HTML entities
    text = text
      .replace(/&nbsp;/g, ' ')
      .replace(/&rsquo;/g, "'")
      .replace(/&ldquo;/g, '"')
      .replace(/&rdquo;/g, '"')
      .replace(/&amp;/g, '&')
      .trim();
    return text;
  }

  onSportClick(sport: any, event: Event) {
    if (this.userLoggedIn) {
      this._router.navigate(['/sports', sport.id]);
    } else {
      event.preventDefault();
      event.stopPropagation();
      this.exploreClick.emit();
    }
  }

  onViewAllClick(event: Event) {
    if (this.userLoggedIn) {
      this._router.navigate(['/sports/sports']);
    } else {
      event.preventDefault();
      event.stopPropagation();
      this.exploreClick.emit();
    }
  }
}
